import React, { useEffect, useRef, useState } from "react";
import DataTable from "../_components/datatable/DataTable";
import { useNavigate } from "react-router-dom";
import {
  postGetAllQuestionCategories,
  postUpSertQuestionCategory,
} from "../../core/api/Api";

const QuestionCategories = () => {
  const mounted = useRef(true);
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    { field: "name", headerName: "Name" },
    { field: "description", headerName: "Description" },
    {
      field: "general_category",
      headerName: "General Category",
      renderCell: (params) => params?.value?.name ?? "",
    },
  ];

  const getData = (data) => {
    setLoading(true);
    postGetAllQuestionCategories(data)
      .then((res) => {
        setLoading(false);
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          setData(data);
        }
      })
      .catch((e) => {
        if (mounted.current) setLoading(false);
      });
  };

  const onDeleteDataTableRows = (data) => {
    setLoading(true);
    postUpSertQuestionCategory(data)
      .then((res) => {
        setLoading(false);
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          setData(data);
        }
      })
      .catch((e) => {
        if (mounted.current) setLoading(false);
      });
  };

  const onRowClick = (e) => {
    navigate("/question-category-details/" + e.id);
  };

  const onCreateButtonClick = () => {
    navigate("/question-category-details/create");
  };

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <DataTable
      columns={columns}
      data={data}
      loading={loading}
      onPageChangeProp={getData}
      onRowClick={onRowClick}
      onCreateButtonClick={onCreateButtonClick}
      onDeleteDataTableRows={onDeleteDataTableRows}
    />
  );
};

export default QuestionCategories;
